import $ from 'jquery';

function toggleNav () {
  // console.log('Header link click', event);
  $('.js-app-nav').fadeToggle(300);
  $('.js-menu-icon').toggleClass('open');
  $('.js-header-link-text div:nth-child(2)').toggleClass('show');
  $('body').toggleClass('overflow-hidden');
  $('body').toggleClass('nav-is-open');
}

export default class Header {
  init () {
    // console.log('Header init')

    // Bind menu button
    $('.js-header-link').on('click', function (event) {
      event.preventDefault();
      toggleNav();
    });
  }
}
